import React, { forwardRef, type ReactNode } from 'react';
import {
  IconButton as MuiIconButton,
  type IconButtonProps,
} from '@mui/material';

type CustomIconButtonProps = IconButtonProps & {
  children: ReactNode;
};

const IconButton = forwardRef<HTMLButtonElement, CustomIconButtonProps>(
  function IconButton({ children, size = 'small', ...props }, ref) {
    return (
      <MuiIconButton ref={ref} size={size} {...props}>
        {children}
      </MuiIconButton>
    );
  }
);

export default IconButton;
